import React from "react";
import PropTypes from "prop-types";
import { Label } from "reactstrap";
import { Field, ErrorMessage } from "formik";

const RavenFormikDefaultComp = ({
  name,
  label,
  maxLength,
  divClassName,
  getClassNameValue,
  disabled,
  placeholder,
  hideLabel,
  style,
  type,
  value,
  onChange,
  handleOnChange,
}) => {
  return (
    <div id={name + "_div"} className={divClassName || "mb-3"}>
      {!hideLabel && <Label className="form-label">{label}</Label>}
      <Field
        name={name}
        type={type}
        className={getClassNameValue}
        disabled={disabled}
        placeholder={placeholder}
        maxLength={maxLength}
        style={style}
        {...(value ? { value: value } : {})}
        {...(onChange ? { onChange: handleOnChange } : {})}
      />
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </div>
  );
};

RavenFormikDefaultComp.propTypes = {
  name: PropTypes.any,
  label: PropTypes.any,
  maxLength: PropTypes.any,
  style: PropTypes.any,
  type: PropTypes.any,
  divClassName: PropTypes.any,
  disabled: PropTypes.bool,
  placeholder: PropTypes.any,
  hideLabel: PropTypes.bool,
  getClassNameValue: PropTypes.any,
  value: PropTypes.any,
  onChange: PropTypes.any,
  handleOnChange: PropTypes.any,
};

export default RavenFormikDefaultComp;
